import { render, staticRenderFns } from "./ViewStyleAdmin.vue?vue&type=template&id=d2228892&scoped=true&"
import script from "./ViewStyleAdmin.vue?vue&type=script&lang=js&"
export * from "./ViewStyleAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2228892",
  null
  
)

export default component.exports